import React from "react";
import styled from "styled-components";

const Loader = ({ color = "#453227" }) => {
  return (
    <Wrapper>
      {Array(5)
        .fill(0)
        .map((_, index) => (
          <div
            key={index}
            style={{ backgroundColor: color }}
            id={`loader-wave-${index + 1}`}
          ></div>
        ))}
    </Wrapper>
  );
};

export default Loader;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 10vh auto;
  width: max-content;

  > div {
    width: 10px;
    height: 100px;
    margin: 0 2px;
    /* background: var(--color-primary-4); */
    animation: loader-animation 1000ms ease-in-out infinite backwards;
    @keyframes loader-animation {
      0% {
        transform: scaleY(0.4);
      }
      20% {
        transform: scaleY(1);
      }
      40% {
        transform: scaleY(0.4);
      }
      100% {
        transform: scaleY(0.4);
      }
    }
  }
  #loader-wave-1 {
    animation-delay: 0ms;
  }
  #loader-wave-2 {
    animation-delay: 100ms;
  }
  #loader-wave-3 {
    animation-delay: 200ms;
  }
  #loader-wave-4 {
    animation-delay: 300ms;
  }
  #loader-wave-5 {
    animation-delay: 400ms;
  }
`;
